<template>
    <div class="data-list">
        <div class="search-wrap">
            <bread-crumb
                :list="crumbList"
                :levels-info-list="levelsInfoList">
            </bread-crumb>
            <div class="input-content">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="排序方式">
                        <el-radio-group v-model="sortWay" size="mini" @change="sortWayChange">
                            <el-radio-button label="name">名称</el-radio-button>
                            <el-radio-button label="appendTime" >添加时间</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="搜索">
                        <el-input
                            clearable
                            placeholder="请输入内容"
                            prefix-icon="el-icon-search"
                            v-model="searchForm.input"
                            @input="onInputChange">
                            <el-button slot="append" @click.stop="searchValue = ''">显示全部</el-button>
                        </el-input>
                    </el-form-item>
                    <!-- <el-form-item v-if="currStep === 'shi'">
                        <el-button
                            class="header-opt-buttom"
                            type="primary"
                            @click="onExprotClass('text')">导出</el-button>
                    </el-form-item> -->
                    <el-button
                            class="header-opt-buttom"
                            type="primary"
                            @click="onExprotClass('text')">导出</el-button>
                </el-form>
            </div>
        </div>
        <div class="list-optering" v-if="hasAdminAuth">
            <template v-if="currStep === 'clou'">
                <el-button
                    class="header-opt-buttom"
                    type="primary"
                    @click="onEditFromKeys">字段信息管理</el-button>
                <el-button
                    class="header-opt-buttom"
                    type="primary"
                    @click="jumpToFolderManager">管理员</el-button>
                <el-popconfirm
                    confirmButtonText='是'
                    cancelButtonText='否'
                    icon="el-icon-info"
                    iconColor="red"
                    title="小程序页面是否显示 logo"
                    @onConfirm="onGetCode(true)"
                    @onCancel="onGetCode(false)"
                    >
                    <el-button
                        class="header-opt-buttom"
                        slot="reference"
                        :loading="loading.qrcode"
                        :disabled="loading.qrcode">二维码</el-button>
                </el-popconfirm>
                <!-- <el-dropdown>
                    <el-button
                        class="header-opt-buttom">导出
                        <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="onExprotClass()">默认导出</el-dropdown-item>
                        <el-dropdown-item @click.native="onExprotClass('text')">文本导出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
            </template>
        </div>
        <div class="list-wrap" v-loading="loading.folderList">
            <!-- 正常列表 -->
            <el-row :gutter="80">
                <!-- 新建 -->
                <el-col v-if="hasAdminAuth" :span="3">
                    <base-folder
                        :is-new="true" 
                        @onClick="onNewFolder">
                    </base-folder>
                </el-col>
                <el-col
                    v-for="(item, i) in displayList"
                    :key="i"
                    :span="3">
                    <base-folder
                        :read-only="!hasAdminAuth"
                        :name="item.name"
                        :row="item"
                        :is-data="currStep === 'data'"
                        :data-nums="item.fileNum"
                        :img-nums="item.photoNum"
                        :invalidTime="item.invalidTime"
                        v-bind="config"
                        @onClick="onFolderClick(item.id)"
                        @modify="onModify(item)"
                        @del="deleteFolder(item)"
                        @down="exprotByDefault(item.id)">
                    </base-folder>
                </el-col>
            </el-row>
            <div class="no-data" v-if="searchValue && !displayList.length">
                <p><i style="font-size: 50px;" class="el-icon-document-delete"></i></p>
                <p class="no-data-text">未匹配到搜索结果！</p>
            </div>
        </div>
        <!-- 添加数据 -->
        <add-data-dialog
            ref="addData"
            v-if="isShowAddDataDialogShow"
            :is-add="isNewFolder"
            :folder-id="folderId"
            :modify-id="modifyDataId"
            :levels="levels"
            :levels-info-list="levelsInfoList"
            :show="isShowAddDataDialogShow"
            @hide="hideAddDataDialog">
        </add-data-dialog>
        <!-- 添加文件夹 -->
        <add-folder-dialog
            ref="addFolder"
            v-if="isAddFolderDialogShow"
            :is-show="isAddFolderDialogShow"
            :is-new="isNewFolder"
            :curr-step-name="currStepName"
            :level-list="levelList"
            :value="{ name: modifyfFolderName, id: currLevelFolderId, modifyId: modifyfFolderId, invalidTime: modifyFolderInvalidTime }"
            @hide="hideAddFolderDialog">
        </add-folder-dialog>
        <!-- 二维码 -->
        <el-dialog :title="''" width="500px" center :visible.sync="isShowQRCodeDialog">
            <img :src="QRCode.url" alt="二维码">
            <div class="qrcode-center-content">
                <p class="class-info">{{ QRCodeTitle }}</p>
            </div>
        </el-dialog>
        <!-- 导出 -->
        <exprot-folder-dialog
            :exprot-name="currFolderName"
            :folder-id="folderId"
            :isShow="isExprotFolderDialogShow"
            @hide="isExprotFolderDialogShow = false">
        </exprot-folder-dialog>
    </div>
</template>
<script>
    import api from '@/api/index.js'
    import time from '@/utils/time.js'
    import BaseFolder from '@/components/BaseFolder.vue'
    import BreadCrumb from '@/components/BreadCrumb.vue'
    import AddDataDialog from './AddDataDialog.vue'
    import AddFolderDialog from './AddFolderDialog.vue'
    import ExprotFolderDialog from './ExprotFolderDialog'
    import { ALL_STEP, STEP_CONFIG } from '@/config/level.js'
    import { deepClone } from '@/utils/tools.js'
    import down from '@/mixins/down.js'
    export default {
        name: 'FolderList',
        components: {
            BaseFolder,
            BreadCrumb,
            AddDataDialog,
            AddFolderDialog,
            ExprotFolderDialog
        },
        mixins: [down],
        props: {
            levels: {
                type: String,
                default: ''
            }
        },
        inject: ['reload'],
        data() {
            const stepConfig = Object.keys(STEP_CONFIG).reduce((acc, cur) => {
                acc.push({
                    key: cur,
                    name: STEP_CONFIG[cur].name
                })
                return acc
            }, [])
            return {
                sortWay: 'appendTime',
                stepConfig: stepConfig,
                searchForm: {
                    input: ''
                },
                folderId: this.levels.split(',').pop(),
                levelList: ['0'], // 当前层级列表,默认在顶层
                levelsInfoList: [],
                list: [], // 文件夹列表
                searchList: [], // 搜索结果
                newFolder: require('../../assets/img/new-folder.png'),
                folder: require('../../assets/img/folder.png'),
                searchValue: '',
                modifyfFolderName: '', // 正在修改的文件夹名称
                modifyFolderInvalidTime: null, // 正在修改的文件夹过期时间
                modifyfFolderId: '', // 修改的文件夹 id
                modifyDataId: '', // 修改的文件id
                isNewFolder: false, // 是否为新建
                isAddFolderDialogShow: false, // 添加文件夹弹窗
                isShowAddDataDialogShow: false, // 添加资料弹窗
                isShowQRCodeDialog: false, // 二维码弹窗
                isExprotFolderDialogShow: false, // 导出文件夹
                QRCode: {
                    url: '', // 二维码链接
                },
                loading: {
                    folderList: false, // 文件列表
                    qrcode: false // 二维码按钮
                }
            }
        },
        computed: {
            displayList () {
                const showList = this.searchValue ? this.searchList : this.list
                if (this.sortWay === 'name') {
                    return deepClone(showList).sort((a, b) => a.name.localeCompare(b.name,'zh'))
                }
                return showList
            },
            currStep () {
                return ALL_STEP[this.levelList.length - 1]
            },
            config () {
                return STEP_CONFIG[this.currStep].props
            },
            currStepName () {
                return STEP_CONFIG[this.currStep].name
            },
            addFolderDialog () { // 修改，添加 title
                if (this.isNewFolder) {
                    return '添加' + STEP_CONFIG[currStep].name
                }
                return '修改名称'
            },
            crumbList () {
                const index = this.levelList.length
                const list = []
                this.stepConfig.slice(0, index).forEach((m, i) => {
                    list.push({
                        name: this.levelsInfoList[i - 1] || m.name,
                        levels: this.levelList.slice(0, i + 1).join(',')
                    })
                })
                return list
            },
            currLevelFolderId () { // 当前层级所属父文件夹 id
                return this.levelList.slice(-1)[0] || ''
            },
            QRCodeTitle () { // 小程序 title
                const name = this.levelsInfoList.slice(-2).join('>')
                return name || '二维码'
            },
            hasAdminAuth () {
                return this.$store.getters.adminAuth
            },
            currFolderName () {
                return deepClone(this.levelsInfoList).pop() || ''
            }
        },
        watch: {
            '$route' () {
                this.reload()
            }
        },
        mounted () {
            if (this.levels) {
                this.levelList = this.levels.split(',')
            }
            if (this.currStep === 'data') {
                this.getDataList()
            } else {
                this.getFolderList()
            }
            if (this.levelList.length > 1) {
                this.getLevelsInfo()
            }
        },
        methods: {
            // get folder list
            async getFolderList () {
                try {
                    this.loading.folderList = true
                    const resp = await api.loadFolderLit({
                        parentId: this.currLevelFolderId, // 文件夹id
                        page: undefined, // 页码 没有就不传
                        row: undefined, // 条数 没有就不传
                        orderBy: undefined // 排序 没有就不传
                    })
                    if (resp.success) {
                        this.list = resp.data.list.map(m => ({
                            name: m.folderName,
                            id: m.folderId,
                            photoNum: m.photoNum,
                            fileNum: m.fileNum,
                            invalidTime: m.invalidTime
                        }))
                    } else {
                        this.$message.error(resp.message)
                    }
                } catch (error) {
                    this.$message.error(error.message)
                } finally {
                    this.loading.folderList = false
                }
            },
            // 获取数据列表
            async getDataList () {
                try {
                    this.loading.folderList = true
                    const resp = await api.loadFileDataList({
                        folderId: this.currLevelFolderId, // 文件夹id
                        page: undefined, // 页码 没有就不传
                        row: undefined, // 条数 没有就不传
                        orderBy: undefined // 排序 没有就不传
                    })
                    if (resp.success) {
                        this.list = resp.data.list.map(m => ({
                            name: m.stuName,
                            id: m.batchId,
                            photoNum: m.photoNum
                        }))
                    } else {
                        this.$message.error(resp.message)
                    }
                } catch (error) {
                    this.$message.error(error.message)
                } finally {
                    this.loading.folderList = false
                }
            },
            // 获取文件路径详情
            async getLevelsInfo () {
                try {
                    const resp = await api.loadLevelsInfo({
                        levels: this.levels
                    })
                    if (resp.success) {
                        this.levelsInfoList = resp.data.map(m => m.folderName)
                    } else {
                        this.$message.error(resp.message)
                    }
                } catch (error) {
                    this.$message.error(error.message)
                }
            },
            // 添加文件夹
            onFolderClick (id) {
                // 添加,修改、数据
                if (this.currStep === 'data') {
                    this.isNewFolder = false
                    this.isShowAddDataDialogShow = true
                    if (!this.isNewFolder) {
                        this.modifyDataId = id
                    }
                    return
                }
                // 切换层级
                if (id) {
                    this.levelList.push(id)
                    this.$router.push({
                        name: 'FolderList',
                        params: { levels: this.levelList.join(',') }
                    })
                }
            },
            // 搜索结果
            onInputChange (val) {
                this.searchValue = val
                const list = deepClone(this.list)
                const results = list.filter(item => {
                    return item.name.indexOf(val) !== -1
                })
                this.searchList = results
            },
            // 新建文件夹
            onNewFolder () {
                this.isNewFolder = true
                // 新建数据
                if (this.currStep === 'data') {
                    this.isShowAddDataDialogShow = true
                    return
                }
                this.isAddFolderDialogShow = true
                this.modifyfFolderName = ''
                this.modifyFolderInvalidTime = null
            },
            // 删除文件、文件夹
            deleteFolder (row) {
                this.$confirm(`确定删除【${row.name}】\?`).then(async () => {
                    try {
                        let delMethod = 'deleteFolder'
                        let reloadMethod = 'getFolderList'
                        let data = {
                            folderId: row.id
                        }
                        if (this.currStep === 'data') { // 删除文件
                            delMethod = 'delFileData'
                            reloadMethod = 'getDataList'
                            data = {
                                batchId: row.id
                            }
                        }
                        const resp = await api[delMethod](data)
                        if (resp.success) {
                            this[reloadMethod]()
                            this.$message.success('删除成功');
                        } else {
                            this.$message.error(resp.message)
                        }
                    } catch (error) {
                        this.$message.error(error.message)
                    }
                })
            },
            // 修改文件夹
            onModify (item) {
                this.isNewFolder = false
                this.isAddFolderDialogShow = true
                this.modifyfFolderName = item.name
                this.modifyfFolderId = item.id
                this.modifyFolderInvalidTime = item.invalidTime
            },
            // 编辑字段信息
            onEditFromKeys () {
                this.$router.push({
                    path: '/scheme',
                    query: {
                        levels: this.levelList.join(',')
                    }
                })
            },
            // 关闭添加资料弹窗
            hideAddDataDialog (reload) {
                if (reload) {
                    // this
                    this.getDataList()
                }
                this.isShowAddDataDialogShow = false
            },
            // 关闭添加文件夹弹窗
            hideAddFolderDialog (success) {
                this.isAddFolderDialogShow = false
                if (success) {
                    this.getFolderList()
                }
            },
            // 导出 文件夹 文件
            /**
             * mode 导出模式，default 导出文件 + 图片； text 导出班级下库 excel 文字信息汇总
             */
            onExprotClass (mode = 'default') {
                const id = this.folderId
                const notifyCls = 'downFilderIng' + id
                if (this.downloadQueue[notifyCls]) {
                    this.$message.error(id + '，该文件已在下载中。。。');
                    return false
                }
                if (mode === 'text') {
                    this.exprotByField(id)
                } else {
                    this.exprotByDefault(id)
                }
            },
            // 通过可选字段导出
            exprotByField () {
                this.isExprotFolderDialogShow = true
            },
            // 默认方式导出文件/文件夹
            async exprotByDefault (id) {
                try {
                    let data = {
                        folderId: id
                    }
                    if (this.currStep === 'data') {
                        data = {
                            batchId: id
                        }
                    }
                    await this.__pushToDownList(id)

                    const resp = await api.downloadFolder(data, (pro) => {
                        this.__updateDownProgressData(id, pro)
                    })

                    const item = this.list.find(m => m.id === id)
                    const name = item ? item.name : this.levelsInfoList.slice(-1)
                    this.__completeDownload(id, resp, name)
                    
                } catch (error) {
                    this.$message.error(error.message)
                }
            },
            async onGetCode (showLogo) {
                try {
                    this.loading.qrcode = true
                    const resp = await api.loadQRCode({
                        scene: `folderId=${this.folderId}&showLogo=${showLogo}`
                    })
                    this.QRCode.url = resp
                    this.isShowQRCodeDialog = true
                } catch (error) {
                    this.$message.error(error.message)
                } finally {
                    this.loading.qrcode = false
                }
            },
            arrayBufferToBase64( buffer ) {
                var binary = '';
                var bytes = new Uint8Array( buffer );
                var len = bytes.byteLength;
                for (var i = 0; i < len; i++) {
                    binary += String.fromCharCode( bytes[ i ] );
                }
                return window.btoa( binary );
            },
            jumpToFolderManager () {
                this.$router.push({
                    path: '/folderManager',
                    query: {
                        levels: this.levelList.join(',')
                    }
                })
            },
            // 文件/文件夹 排序方式改变
            sortWayChange () {
                
            }
        }
    }
</script>

<style lang="scss" scoped>
.data-list {
    // padding: 0px 60px 20px 20px;
}
.header-opt-buttom {
    margin: 0 4px;
}
.search-wrap {
    margin-top: 10px;
    padding-left: 20px;
    overflow: hidden;
    line-height: 32px;
    .input-content {
        float: right;
    }
}
.list-wrap {
    clear: both;
    padding: 0px 60px 20px 20px;
    min-height: 400px;
}
.ui-base-card {
    margin-top: 20px;
    display: inline-block;
    position: relative;
    width: 125px;
    height: 125px;
    cursor: pointer;
    background: none;
    &:hover .card-bottom-group{
        opacity: 1;
        right: -30px;
    }
}
.card-bottom-group {
    position: absolute;
    right: 0px;
    top: 10px;
    opacity: 0;
    transition: all .3s;
    .card-bottom {
        margin-top: 10px;
        padding: 2px 6px;
        color: #fff;
        text-align: center;
        border-radius: 8px;
        font-size: 12px;
        &.submit {
            background: #32d396;
        }
        &.dow {
            background: #1e87f0;
        }
        &.del {
            background: #ff7272;
        }
        &.modify {
            background: #faa05a;
        }
    }
}
.ui-folder-img {
    width: 100%;
    height: 100%;
    overflow: hidden;
    img {
        width: 100%;
        height: 100%;
    }
}

.text-content {
    margin-top: -10px;
    text-align: center;
    .folder-status {
        color: #888888;
        font-size: 14px;
        & > span:not(:first-child) {
            margin-left: 10px;
        }
    }
}
.folder-info {
    position: absolute;
    left: 10px;
    top: 64px;
    color: #ffffff;
    opacity: .7;
    font-size: 14px;
}
.list-optering {
    margin-left: 20px;
}
.no-data {
    margin-top: 100px;
    width: 100%;
    text-align: center;
    .no-data-text {
        font-size: 14px;
        color: #888888;
    }
}
.qrcode-center-content {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 39%;
    height: 38%;
    background: #ffffff;
    transform: translate(-55%, -45%);
    border-radius: 50%;
    text-align: center;
    .class-info {
    }
}
</style>